const condominiumsApi = ({ apiClient }) => ({
  getAllFromRealEstate(params, headers = {}) {
    return apiClient.get('condominiums/real-estate', {}, params, headers)
  },
  list(params) {
    return apiClient.get(`condominiums`, {}, params)
  },
  show(id) {
    return apiClient.get(`condominiums/${id}`)
  },
  store(payload = {}) {
    return apiClient.post(`condominiums`, payload)
  },
  update(id, payload = {}) {
    return apiClient.put(`condominiums/${id}`, payload)
  },
})
export default condominiumsApi
